/** Lets chat-submit await any pending DrawioEditor buffer flush before
 *  pinging the orchestrator. Only one DrawioEditor mounts at a time. */

let flushFn: (() => Promise<void>) | null = null;

export const setFlushFn = (fn: (() => Promise<void>) | null): void => {
  flushFn = fn;
};

/** Resolves immediately if no DrawioEditor is mounted. */
export const flushDrawioBuffer = async (): Promise<void> => {
  if (flushFn) await flushFn();
};
